(function() {
  var CARRIERS = {
    mondialrelay: {
      name: 'Mondial Relay',
      url: 'https://www.mondialrelay.fr/suivi-de-colis?numeroExpedition=',
      test: function(n) { return /^\d{8,12}$/.test(n); }
    },
    chronopost: {
      name: 'Chronopost',
      url: 'https://www.chronopost.fr/tracking-no-powerful/tracking-search/',
      test: function(n) { return /^\d{13}$/.test(n); }
    },
    colissimo: {
      name: 'Colissimo',
      url: 'https://www.laposte.fr/outils/suivre-vos-envois?code=',
      test: function() { return true; } // catch-all
    }
  };

  var ORDER = ['mondialrelay', 'chronopost', 'colissimo'];

  var input = document.querySelector('[data-tracking-input]');
  var submitBtn = document.querySelector('[data-tracking-submit]');
  var errorEl = document.querySelector('[data-tracking-error]');
  if (!input || !submitBtn) return;

  function trackPackage() {
    var num = input.value.trim().replace(/\s/g, '');
    if (errorEl) errorEl.style.display = 'none';

    if (!num || num.length < 8) {
      if (errorEl) { errorEl.textContent = 'Veuillez entrer un numéro de suivi valide.'; errorEl.style.display = ''; }
      input.focus();
      return;
    }

    for (var i = 0; i < ORDER.length; i++) {
      var carrier = CARRIERS[ORDER[i]];
      if (carrier.test(num)) {
        window.open(carrier.url + encodeURIComponent(num), '_blank');
        return;
      }
    }
  }

  submitBtn.addEventListener('click', trackPackage);
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); trackPackage(); }
  });
})();
